<template>
  <div class="phone-input-wrapper">
    <div class="phone-prefix-select" @click="$emit('toggle-dropdown')">
      {{ prefix }}
      <span class="arrow">
        <img src="../../assets/Keeta/1.3.png" alt="" />
      </span>
      <ul v-if="dropdownVisible" class="phone-prefix-options">
        <li
          v-for="item in prefixList"
          :key="item.code"
          @click.stop="$emit('select-prefix', item)"
          :class="{ active: '+' + item.code === prefix }"
        >
          +{{ item.code }}
        </li>
      </ul>
    </div>
    <div class="phone-divider"></div>
    <div
      class="phone-input"
      contenteditable="true"
      :placeholder="$t('home_partner_input_phone')"
      @input="onInput"
    ></div>
  </div>
</template>

<script>
export default {
  name: "PhoneInput",
  props: {
    prefix: {
      type: String,
      default: "+852",
    },
    prefixList: {
      type: Array,
      default: () => [],
    },
    dropdownVisible: {
      type: Boolean,
      default: false,
    },
    clearTrigger: {
      type: [Number, String, Boolean],
      default: 0,
    },
  },
  methods: {
    onInput(event) {
      const value = event.target.innerText.trim();
      this.$emit("mobile", { mobile: value, regionCode: this.prefix });
    },
  },
  watch: {
    clearTrigger() {
      this.$nextTick(() => {
        const inputDiv = this.$el.querySelector(
          '.phone-input[contenteditable="true"]'
        );
        if (inputDiv) inputDiv.innerText = "";
      });
    },
  },
};
</script>

<style scoped lang="scss">
.phone-input-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  border: 1px solid #cccccc;
  border-radius: 12px;
  position: relative;
}

.phone-prefix-select {
  padding: 0 10px 0 20px;
  display: flex;
  align-items: center;
  font-size: 18px;
  cursor: pointer;
  position: relative;

  .arrow {
    margin-left: 8px;

    img {
      width: 14px;
      height: 14px;
    }
  }
}

.phone-prefix-options {
  position: absolute;
  top: 110%;
  left: 0;
  width: 100px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  list-style: none;
  z-index: 10;

  li {
    padding: 10px;
    font-size: 16px;
    cursor: pointer;

    &:hover {
      background: #f0f0f0;
    }

    &.active {
      background: #f0f0f0;
    }
  }
}

.phone-divider {
  width: 1px;
  height: 35px;
  background: #eee;
  margin: 0 10px;
}

.phone-input {
  padding: 18px 10px;
  flex: 1;

  &:empty:before {
    content: attr(placeholder);
    color: #999;
  }

  &:focus,
  &:focus-visible {
    border-color: #000;
    outline: none;
  }

  &:focus:before {
    content: "";
  }
}
</style>
